// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3ngc7","content":"RecentSearches_content__20Cx7"};